import { SoilMapView } from "../../omnia"

export type MapViewGroup = ReturnType<typeof createMapViewGroup>

export function createMapViewGroup(key: string, name: string, views: SoilMapView[]) {

    return {

        currentView: undefined as SoilMapView,

        get key() { return key },
        get name() { return name },
        get views() { return views },

        hasMultipleViews() {
            return views.length > 1
        }

    }

}
